/* EQ · Fiche produit — les blocs « onglet repliable » consécutifs forment une barre d'onglets sur ordinateur (spec 2:1027), accordéon sur mobile. */
(function(){
  function build(){
    const info = document.querySelector('.product__info-wrapper'); if(!info) return;
    const accs = [...info.querySelectorAll('.product__accordion')]; if(accs.length < 2) return;
    if(info.querySelector('.eq-tabs')) return;
    const bar = document.createElement('div'); bar.className='eq-tabs'; bar.setAttribute('role','tablist');
    accs.forEach((acc,i)=>{
      const d=acc.querySelector('details'); const title=(acc.querySelector('.accordion__title')||{}).textContent||('Onglet '+(i+1));
      const b=document.createElement('button'); b.type='button'; b.className='eq-tabs__tab'+(i===0?' is-active':''); b.textContent=title.trim(); b.setAttribute('role','tab');
      b.addEventListener('click',()=>{ bar.querySelectorAll('.eq-tabs__tab').forEach(x=>x.classList.remove('is-active')); b.classList.add('is-active'); accs.forEach((a,j)=>{ a.classList.toggle('is-active', j===i); const dd=a.querySelector('details'); if(dd) dd.open = (j===i); }); });
      bar.appendChild(b);
      acc.classList.add('eq-tabs__panel'); if(i===0){ acc.classList.add('is-active'); if(d) d.open=true; }
    });
    accs[0].parentNode.insertBefore(bar, accs[0]);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', build); else build();
  document.addEventListener('shopify:section:load', build);
})();
